import { Layouts } from '@/api'
import getBase64Image from '@/utils/getBase64Image'

const initialState = () => {
    return {
        layoutsList: [],
    }
}

const state = initialState() 

const getters = {
    getList(state) {
        return state.layoutsList
    },
    getById: (state) => async (id) => {
        const layout = state.layoutsList.find((layout) => layout.id === id)
        if (!layout?.image?.url) return layout

        layout.image.data = await getBase64Image(layout.image.url)
        return state.layoutsList.find((layout) => layout.id === id)
    },
    getByNameEui: (state) => async (name) => {
        const layout = state.layoutsList.find((layout) => layout.name_eui === name)
        if (!layout?.image?.url) return layout

        layout.image.data = await getBase64Image(layout.image.url)
        return layout
    },
}

const actions = {
    async fetchList({ commit }) {
        try {
            const response = await Layouts.list()
            const layouts = response.data.map((layout) => {
                const id = layout._id
                delete layout._id
                return { id, ...layout }
            })
            commit('SET_LIST', layouts)
        } catch (error) {
            throw error
        }
    },
    async addLayout({ commit }, layout) {
        try {
            const response = await Layouts.add(layout)
            const id = response.data._id
            delete response.data._id
            commit('ADD_LAYOUT', { id, ...response.data, nodes: [] })
            return { id, ...response.data, nodes: [] }
        } catch (error) {
            throw error
        }
    },
    async updateLayout({ commit }, layout) {
        const response = await Layouts.update(layout.id, layout.update)
        const id = response.data._id
        delete response.data._id

        commit('UPDATE_LAYOUT', { id, ...response.data })
        return response.data
    },
    async deleteLayout({ commit }, layoutId) {
        await Layouts.deletion(layoutId)
        commit('DELETE_LAYOUT', layoutId)
    },
    async addNodeLayout({ commit }, { layoutId, node }) {
        const { ref, name, x, y, width, height, shape, color } = node

        const response = await Layouts.addNode(layoutId, {
            ref,
            name,
            x,
            y,
            width,
            height,
            attributes: { shape, color },
        })

        commit('ADD_NODE_LAYOUT', { id: layoutId, node: response.data })
        return response.data
    },
    async deleteNodeLayout({ commit }, { layoutId, nodeId }) {
        await Layouts.deleteNode(layoutId, nodeId)
        commit('DELETE_NODE_LAYOUT', { layoutId, nodeId })
    },
    async updateNodeLayout({ commit, state }, { layoutId, nodeId, update }) {
        let updateBody = { ...update }
        if (updateBody.attributes) {
            const layout = state.layoutsList.find((layout) => layout.id === layoutId)
            const node = layout.nodes.find((node) => node.id === nodeId)
            updateBody.attributes = {
                ...node.attributes,
                ...updateBody.attributes,
            }
        }

        const response = await Layouts.updateNode(layoutId, nodeId, updateBody)
        commit('UPDATE_NODE_LAYOUT', { layoutId, node: response.data })
        return response.data
    },
}

const mutations = {
    SET_LIST(state, list) {
        state.layoutsList = list
    },
    ADD_LAYOUT(state, layout) {
        state.layoutsList.push(layout)
    },
    UPDATE_LAYOUT(state, layout) {
        const index = state.layoutsList.findIndex((l) => l.id === layout.id)
        state.layoutsList.splice(index, 1, layout)
    },
    DELETE_LAYOUT(state, layoutId) {
        const index = state.layoutsList.findIndex((l) => l.id === layoutId)
        state.layoutsList.splice(index, 1)
    },
    ADD_NODE_LAYOUT(state, { id, node }) {
        const layout = state.layoutsList.findIndex((layout) => layout.id === id)
        const nodes = state.layoutsList[layout].nodes
        nodes.push(node)

        state.layoutsList[layout].nodes = nodes
    },
    DELETE_NODE_LAYOUT(state, { layoutId, nodeId }) {
        const layout = state.layoutsList.find(item => item.id === layoutId)
        layout.nodes = layout.nodes.filter(node => node.id !== nodeId)
    },
    UPDATE_NODE_LAYOUT(state, { layoutId, node }) {
        const layout = state.layoutsList.findIndex((layout) => layout.id === layoutId)
        const nodes = state.layoutsList[layout].nodes
        const index = nodes.findIndex((n) => n.id === node.id)

        nodes.splice(index, 1, node)
        state.layoutsList[layout].nodes = nodes
    },
    RESET(state) {
        Object.assign(state, initialState())
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
